/**
 * Fehler eines API-Aufrufs in eine kurze, anzeigbare Zeile übersetzen.
 *
 * Ein Banner, das nur "hat nicht geklappt" sagt, kostet den Support eine
 * Rückfrage. Was hier herauskommt, steht deshalb mit im Banner: Statuscode und
 * Meldung des Backends — oder, wenn es gar nicht bis zum Aufruf kam, der Grund
 * dafür. Kurz genug für eine Zeile, konkret genug für ein Ticket.
 */
export function describeError(error) {
  if (!error) return "Unbekannter Fehler";
  if (typeof error === "string") return error;

  if (error.response) {
    const detail = backendDetail(error.response.data) || error.response.statusText;
    return detail ? `HTTP ${error.response.status} · ${detail}` : `HTTP ${error.response.status}`;
  }

  if (error.code === "ECONNABORTED") {
    return "Zeitüberschreitung — der Server hat nicht geantwortet";
  }
  if (error.request) {
    return "Keine Antwort vom Server — Netzwerkverbindung oder Firewall prüfen";
  }

  const message = String(error.message || error);
  if (/token|auth/i.test(message)) {
    return "Anmeldung fehlgeschlagen — Add-in schliessen und neu öffnen";
  }
  return truncate(message);
}

function backendDetail(data) {
  if (!data) return "";
  if (typeof data === "string") return truncate(data);

  const detail = data.detail ?? data.message ?? data.error;
  if (Array.isArray(detail)) {
    // Validierungsfehler von FastAPI: `loc` benennt das Feld, das fehlt oder
    // nicht passt — genau die Angabe, die dem Support sonst fehlt.
    return truncate(
      detail
        .map((entry) => {
          const field = (entry.loc || []).filter((part) => part !== "body").join(".");
          return field ? `${field}: ${entry.msg}` : entry.msg;
        })
        .join(" · "),
    );
  }
  if (typeof detail === "string") return truncate(detail);
  if (detail) return truncate(JSON.stringify(detail));
  return "";
}

function truncate(text, limit = 240) {
  const value = String(text || "").trim();
  return value.length > limit ? `${value.slice(0, limit)}…` : value;
}
